import addClasses from './addClasses';
import removeClasses from './removeClasses';
export default {
  addClasses: addClasses,
  removeClasses: removeClasses
};


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/super-x.blog/httpdocs/~/swiper/esm/components/core/classes/index.js
// module id = 452
// module chunks = 0